// extracted by mini-css-extract-plugin
export default {"module":"Module_module__hXpXu","module-search":"Module_module-search__+EwYu"};